import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { sortListByAttribute } from "./sort-utils";

export type CargillBusinesses = {
  name: string;
}[];

/**
 * Gets businesses list based on translations, sorted for forms.
 * @returns a list of businesses
 */
export function useCargillBusiness() {
  const { t, i18n } = useTranslation();
  const data = useMemo(() => {
    const other = t("request_access:more_information.other");
    const list = t("request_access:employee_access.cargill_business_list");
    const json = JSON.parse(list) as CargillBusinesses;
    const sorted = sortListByAttribute("name", json, other);
    return sorted;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, t]);

  return data;
}
